import React, {useContext} from "react";
import GlobalContext from "../GlobalContext";

const YearNavigator = () => {

  const CONTEXT = useContext(GlobalContext);

    function createYearOptions() {
        let options = [];

        for (let y = CONTEXT.eventsExtremeDates.newest; y >= CONTEXT.eventsExtremeDates.oldest; y--) {
            options.push(<option value={y} key={`ic-${y}`}>{y}</option>);
        }
        return options;
    }

  function setDate(setSelectedYear, y) {
    setSelectedYear(y);
  }

    function handleChangeYear(event) {
        CONTEXT.setSelectedYear(event.target.value);
    }

  return (
    <div className="year-navigator ml-2 d-inline-block">
      <GlobalContext.Consumer>
          {({
                setSelectedYear
            }) => (
              <select className=""
                      onChange={handleChangeYear}
                      value={CONTEXT.selectedYear}
              >
                  {createYearOptions()}
              </select>
          )}
      </GlobalContext.Consumer>
    </div>
  );
};

export default YearNavigator;
